import angular from 'angular';

import './user-form.styles.scss';

import UserFormController from './user-form.controller';

export default angular.module('autoboard.userForm', [])
  .controller('UserFormController', UserFormController)
  .name;
